import {
  addMinutes,
  differenceInMinutes,
  getHours,
  getMinutes,
  getSeconds,
  parse,
  setDate,
  startOfDay,
  endOfDay,
} from 'date-fns';
import { COLOURS } from '../styles';
import {
  faultTable,
  FILTER_OPTIONS,
  modelTypeDetails,
  mType_label_t,
  runOnceTimerOptions,
  socket_types,
  wifiStatusTable,
} from '../constants';
import { devLog } from './devLog';

export const doIhaveAccessToController = () => {};

export const getModelTypeStringFromValue = (modelType) => {
  var str = 'None';
  const found = modelTypeDetails.find((model) => model.value === modelType);
  if (found) {
    str = found.label;
  }
  return str;
};

// export const getDeviceFaults = (device) => {
//   let str = device.ctrlStatDateTooltip;

//   const idx = device.faults[0].indexOf(" ");
//   if(idx > 0) {
//     str = str + device.faults[0].substring(idx);
//   } else {
//     str = str + " " + device.faults[0];
//   }
//   if(device.faults.length > 1) {
//     str = str + " ..";
//   }
//   return str;
// }

// Named constants, not SocketTypesSelect[5]/[6]. Position happens to equal value today, so
// the old form worked, but it meant inserting or reordering an option silently changed what
// the app believes a socket *is* — behaviour, not copy. socket_types is the actual authority.
//
// `?.` is hardening, not a fix for a live crash: every caller reads its register out of
// registerData, which starts as registersInit and is only ever .map()ed or reset back to it,
// so it never loses an address and all fourteen socket/valve/VF type registers are in there.
// A missing register is therefore unreachable today — but these are exported app-wide through
// Common.js, the two call sites in DisplaySocketValveVFStatusItem don't guard, and a predicate
// answering "is this socket a light?" has no business throwing over an absent one. Same rule
// this commit applies to the type tables: an input we don't recognise means no, not a crash.
export const isALight = (type_register) =>
  type_register?.value === socket_types.POOL_LIGHT || type_register?.value === socket_types.SPA_LIGHT;

// socket_types.SANITISER rather than SocketTypesSelect[1] — see isALight above, including why
// the optional chaining is there. Note UV_SANITISER is a separate type and deliberately not
// included, matching the old behaviour.
export const isASanitiser = (type_register) => type_register?.value === socket_types.SANITISER;

export const getLightNumber = (socketNumber) => {
  var lightCount = 0;

  return lightCount;
};

export const isDeviceInFault = (device) => {
  var result = false;
  if (device !== undefined) {
    if (isCurrentFaultsARealFault(device)) {
      result = true;
    }
  } else {
    devLog('device is undefined');
  }
  return result;
};

export const isCurrentFaultsARealFault = (device) => {
  var result = false;
  if (
    device.currentFaults !== 0 &&
    device.currentFaults !== '0' &&
    device.currentFaults !== null &&
    device.currentFaults !== '2147483648'
  ) {
    result = true;
  }
  return result;
};

export const isDeviceGood = (device) => {
  var result = false;
  if (device !== undefined) {
    if (device.connStatDesc === 'ONLINE') {
      if (device.ctrlStatDesc === 'GOOD') {
        result = true;
      }
    }
  }
  return result;
};

export const isDeviceOffline = (device) => {
  var result = true;
  if (device !== undefined) {
    if (device.connStatDesc === 'ONLINE') {
      result = false;
    }
    if ((device.connStatDesc ?? 'undefined').toLowerCase() === 'undefined') {
      result = false;
    }
  }
  return result;
};

export const isDeviceOfflineWithinDateRange = (device, dateRange) => {
  var result = false;

  if (dateRange === undefined || dateRange == null) {
    if (isDeviceOffline(device)) {
      result = true;
    }
  } else {
    const startDate = startOfDay(dateRange[0]);
    const endDate = endOfDay(dateRange[1]);
    // "08/05/2025 09:00:16"
    const deviceDate = parse(device.connStatDate, 'dd/MM/yyyy HH:mm:ss', new Date());

    if (isDeviceOffline(device) && deviceDate >= startDate && deviceDate <= endDate) {
      result = true;
    }
  }
  return result;
};

export const getClosestRunOnInterval = (start, stop) => {
  var interval = runOnceTimerOptions[0];

  let hh = (start & 0xff00) >> 8;
  let mm = start & 0x00ff;

  let hh2 = (stop & 0xff00) >> 8;
  let mm2 = stop & 0x00ff;

  let date1 = new Date(2000, 1, 1, hh, mm, 0);
  let date2 = new Date(2000, 1, 1, hh2, mm2, 0);

  // var result = setMinutes(, 45)

  // date1.setTime .setTime(hour: hh, min: mm, sec: 00);
  // var date2 = Date().setTime(hour: hh2, min: mm2, sec: 00);

  if (start > stop) {
    date2 = setDate(date2, 2);
    // date2 = Calendar.current.date(byAdding: .day, value: 1, to: date2) ?? Date();
  }

  //Calculate difference
  // let cal = Calendar.current
  // let components = cal.dateComponents([.minute], from: date1, to: date2)
  // let diff = components.minute!

  let diff = differenceInMinutes(date2, date1);

  if (diff >= 1 && diff <= runOnceTimerOptions[1].value) {
    interval = runOnceTimerOptions[1];
  } else {
    runOnceTimerOptions.forEach((timer, index) => {
      if (diff >= timer.value) {
        interval = timer;
      }
    });
  }
  // console.log("Diff:",diff ,"Interval found:",interval);
  return interval;
};

export const getRunonStartStopTimesForInterval = (interval) => {
  let date1 = new Date();
  var date2 = date1;

  let sec = getSeconds(date1);

  if (interval !== 0) {
    let valueToAdd = interval + (sec >= 24 ? 1 : 0);
    date2 = addMinutes(date2, valueToAdd);
  }

  // let hh_start = getHours(date1);
  // let mm_start = getMinutes(date1);

  // let hh_end = getHours(date2);
  // let mm_end = getMinutes(date2);
  let start_time = (getHours(date1) << 8) | getMinutes(date1);
  let end_time = (getHours(date2) << 8) | getMinutes(date2);

  devLog('interval', interval, 'run_on Start: ', date1, start_time, 'End: ', date2, end_time);

  return { start: start_time, stop: end_time };
};

export const getUUID_ForInstaller = () => {
  const short = require('short-uuid');

  // Quick start with flickrBase58 format
  let UUID = short.generate(); // 73WakrfVbNJBaAmhQtEeDv

  devLog('UUID', UUID);
  return 'IID_' + UUID;
};

export const build_fault_string = (
  valueToBuildFrom,
  exclude_system_restart,
  no_faults_description,
  use_short_strings,
) => {
  var build_from_value = 0;
  if (typeof valueToBuildFrom === 'string' || valueToBuildFrom instanceof String) {
    build_from_value = parseInt(valueToBuildFrom, 10);
  }
  // it's a string
  else {
    build_from_value = valueToBuildFrom;
  }
  // it's something else
  var colour = COLOURS.warning;
  let str = '';
  let number_faults = 0;
  let idx_max = exclude_system_restart === true ? 31 : 32;
  for (let index = 0; index < idx_max; index++) {
    const bit_field = 1 << index;
    if ((build_from_value & bit_field) === bit_field) {
      let theFault = getFaultTableItem(bit_field);
      if (null !== theFault) {
        if (number_faults !== 0) {
          str += ' , ';
        }
        if (use_short_strings === true) {
          str += theFault.short_label;
        } else {
          str += theFault.label;
        }
        number_faults++;
      }
    }

    // if ((build_from_value & bit_field) === bit_field) {

    //   if ( number_faults !== 0)
    //   {
    //     str += " , "
    //   }

    //   if ( use_short_strings === true)
    //   {
    //     str += fault_strings_short_idx[index+1] ;//+ ",\r\n";
    //   }
    //   else
    //   {
    //     str += fault_strings_idx[index+1] ;//+ ",\r\n";
    //   }
    //   number_faults++;
    //   // console.log( "Number_faults", number_faults, str)
    // }
  }

  if (str === '') {
    str = no_faults_description;
    colour = COLOURS.good;
  }
  var result = {};
  result.string = str;
  result.colour = colour;
  result.number_faults = number_faults;
  return result;
};

export const getFaultTableItem = (faultBit) => {
  var theResult = null;
  const theFault = faultTable.find((item) => item.value === faultBit);
  if (theFault) {
    theResult = theFault;
  }
  return theResult;
};

export const getWifiStatusItem = (wifiBitField) => {
  var theResult = null;
  const statusItem = wifiStatusTable.find((item) => item.value === wifiBitField);
  if (statusItem) {
    theResult = statusItem;
  }
  return theResult;
};

export const getMonthYearFromDate = (dateToProcess) => {
  var theMonth = 0;
  var theYear = 0;
  var theLabel = 'Undefined';
  if (undefined === dateToProcess || null === dateToProcess) {
    devLog('Convert to Date Time Undefined', dateToProcess);
  } else {
    var split = dateToProcess.split('T');
    var parts = split[0].split('-');
    var theDate = 0;
    if (parts[0] > 2000) {
      theMonth = parts[1] - 1;
      theYear = parts[0];
      theDate = parts[2];
    } else {
      theMonth = parts[1] - 1;
      theYear = parts[2];
      theDate = parts[0];
    }

    const date = new Date(theYear, theMonth, theDate); // 2009-11-10
    const monthStr = date.toLocaleString('default', { month: 'short' });

    theLabel = String(monthStr + '-' + theYear);

    // console.log("Convert to Date Time", split,parts, theMonth,theYear, theLabel);
  }
  return { label: theLabel, Month: theMonth, Year: theYear };
};

export const is_a_light_controller = (modelType) => {
  var light_controller = false;

  if (modelType === mType_label_t.AQUALIGHT || modelType === mType_label_t.INSTATOUCH_WIFI) {
    light_controller = true;
  } else {
    // console.log("is_a_light_controller", modelType, "is not a light controller");
  }

  return light_controller;
};

export const isModelTypeSelected = (device, filter) =>
  (filter === FILTER_OPTIONS.modelTypeGroupAquatek && device.modelType === mType_label_t.AQUATEK) ||
  (filter === FILTER_OPTIONS.modelTypeGroupTheralink && device.modelType === mType_label_t.THERALINK) ||
  (filter === FILTER_OPTIONS.modelTypeGroupOasis && device.modelType === mType_label_t.OASIS) ||
  (filter === FILTER_OPTIONS.modelTypeGroupPoolTek &&
    device.modelType.toLowerCase() === mType_label_t.POOLTEK.toLowerCase()) ||
  (filter === FILTER_OPTIONS.modelTypeGroupHenden && device.modelType === mType_label_t.HENDEN) ||
  (filter === FILTER_OPTIONS.modelTypeGroupAqualight && device.modelType === mType_label_t.AQUALIGHT) ||
  device.modelType === mType_label_t.INSTATOUCH_WIFI ||
  (filter === FILTER_OPTIONS.modelTypeGroupSummerTime && device.modelType === mType_label_t.SUMMERTIME) ||
  (filter === FILTER_OPTIONS.modelTypeGroupSWC &&
    (device.modelType === mType_label_t.SWC_DONTEK || device.modelType === mType_label_t.SWC_HENDEN));

export const is_a_SWC = (device) =>
  device.modelType === mType_label_t.SWC_DONTEK || device.modelType === mType_label_t.SWC_HENDEN;
